// ============================================================
// PENNER TIRE — Sodium Highway theme (Shopify build)
// Mobile menu drawer + open/closed indicator.
// Reads window.theme settings injected by layout/theme.liquid.
// ============================================================

(function () {
  'use strict';

  // -----------------------------------------
  // Mobile menu drawer
  // -----------------------------------------
  var menu = document.getElementById('mobile-menu');
  var toggle = document.querySelector('.nav-toggle');

  function setOpen(open) {
    if (!menu || !toggle) return;
    if (open) {
      menu.removeAttribute('hidden');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    } else {
      menu.setAttribute('hidden', '');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }
  }

  window.toggleMobileMenu = function () {
    if (!menu) return;
    setOpen(menu.hasAttribute('hidden'));
  };

  document.querySelectorAll('.mobile-nav a').forEach(function (a) {
    a.addEventListener('click', function () { setOpen(false); });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && menu && !menu.hasAttribute('hidden')) setOpen(false);
  });

  // -----------------------------------------
  // Open/closed indicator
  // Reads schedule from window.theme (injected by layout)
  // Green dot when open, red when closed.
  // -----------------------------------------
  function updateOpenStatus() {
    var cfg = window.theme || {};
    var days = cfg.openDays || { 0: false, 1: true, 2: true, 3: true, 4: true, 5: true, 6: false };
    var openHour = (typeof cfg.openHour === 'number') ? cfg.openHour : 9;
    var closeHour = (typeof cfg.closeHour === 'number') ? cfg.closeHour : 17;
    var schedule = cfg.schedule || 'Mon–Fri 9am–5pm';

    var now = new Date();
    var day = now.getDay();
    var hour = now.getHours();
    var open = days[day] === true && hour >= openHour && hour < closeHour;

    var openLabel = 'Open now · ' + schedule;
    var closedLabel = 'Closed now · Open ' + schedule;

    document.querySelectorAll('.phone-cta').forEach(function (el) {
      el.classList.toggle('closed', !open);
      el.setAttribute('title', open ? openLabel : closedLabel);
    });
  }

  updateOpenStatus();
  setInterval(updateOpenStatus, 60000);

  // -----------------------------------------
  // Cart line-item quantity (basic + / - controls)
  // For the cart template's qty steppers.
  // -----------------------------------------
  document.querySelectorAll('.qty-input').forEach(function (group) {
    var input = group.querySelector('.qty');
    if (!input) return;
    var minus = group.querySelector('button[data-qty="-"]');
    var plus = group.querySelector('button[data-qty="+"]');
    if (minus) minus.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      if (v > 1) input.value = v - 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    if (plus) plus.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = v + 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

})();
